import { createMagic, login, refresh } from './twa-api'
import { EventEmitter } from 'events'
import store from '../store/index.js'

const loggedIn = 'loggedIn'
const accessToken = 'accessToken'
const refreshToken = 'refreshToken'
const loginEvent = 'loginEvent'

class AuthService extends EventEmitter {
  async createMagic (connection, target, recaptcha_response) {
    const response = await createMagic(connection, target, recaptcha_response)
    return response.code
  }

  async login (connection, target, code) {
    const response = await login(connection, target, code)
    const profile = JSON.parse(atob(response.token.split('.')[1]))
    const now = Math.round(Date.now() / 1000)
    console.log('Logged in. Expiry in ' + ((profile.exp - now) / 60).toFixed(2) + ' minutes')

    localStorage.setItem(loggedIn, 'true')
    localStorage.setItem(accessToken, response.token)
    localStorage.setItem(refreshToken, response.refreshToken)

    store.commit('setUser', profile.user)

    this.emit(loginEvent, {
      loggedIn: true,
      profile: profile
    })
    return response
  }

  async refresh () {
    try {
      const token = localStorage.getItem(refreshToken)
      if (token) {
        const response = await refresh(token)
        const profile = JSON.parse(atob(response.token.split('.')[1]))
        const now = Math.round(Date.now() / 1000)
        console.log('Token refreshed. Expiry in ' + ((profile.exp - now) / 60).toFixed(2) + ' minutes')

        localStorage.setItem(loggedIn, 'true')
        localStorage.setItem(accessToken, response.token)

        store.commit('setUser', profile.user)

        this.emit(loginEvent, {
          loggedIn: true,
          profile: profile
        })
      } else {
        console.log('Refresh Token not found. Logging out.')
        this.logOut()
      }
    } catch (e) {
      console.log('Error while refreshing token. Logging out.', e)
      this.logOut()
    }
  }

  isAuthenticated () {
    return localStorage.getItem(loggedIn) === 'true'
  }

  logOut (message = '') {
    message = message ? message + ' Logging out.' : 'Logging out.'
    console.log(message)
    localStorage.removeItem(loggedIn)
    localStorage.removeItem(accessToken)
    localStorage.removeItem(refreshToken)

    store.commit('setUser', null)

    this.emit(loginEvent, {
      loggedIn: false
    })

    // router.push({ path: '/login', query: { redirect: router.currentRoute.path } })
    window.document.location = window.location.origin
  }
}

export default new AuthService()
